import * as React from "react";
import {Snackbar} from "@octopusdeploy/design-system-components";
import InternalNavLink from "components/Navigation/InternalNavLink/InternalNavLink";

interface TaskSnackbarProps {
    open: boolean;
    getLink: () => string;
    onRequestClose: () => void;
}

const TaskSnackbar: React.FC<TaskSnackbarProps> = (props: TaskSnackbarProps) => {
    return <Snackbar
        open={props.open}
        autoHideDuration={3000}
        onClose={props.onRequestClose}
        content={<InternalNavLink to={props.getLink()}>New Task Queued</InternalNavLink>}/>;
};

export default TaskSnackbar;
